import React from 'react'

const Footer = () => {
  return (
    <div className='flex justify-end align-middle p-4 bg-black mb-0 h-20 text-sm text-white font-mono'>
      <p className='mt-6'>Copyright * 2022 Movies rights reserved.</p>
    </div>
  )
}

export default Footer;
